import { Alert, AlertDescription } from "@/components/ui/alert";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Skeleton } from "@/components/ui/skeleton";
import { AlertCircle } from "lucide-react";
import type { KnockMessage } from "../../../types/zod/knock";
import { MessageList } from "./MessageList";

interface Props {
	messages: KnockMessage[];
	isLoading: boolean;
}

export function MessageHistory({ messages, isLoading }: Props) {
	if (isLoading) {
		return (
			<ScrollArea className="h-[calc(100vh-12rem)]">
				<div className="space-y-4 pr-4">
					{Array.from({ length: 3 }).map((_, i) => (
						<div key={`skeleton-${crypto.randomUUID()}`} className="space-y-4">
							<div className="flex justify-between items-center">
								<div className="flex items-center gap-2">
									<Skeleton className="rounded-full w-6 h-6" />
									<Skeleton className="w-48 h-6" />
								</div>
								<Skeleton className="w-24 h-6" />
							</div>
							<Skeleton className="w-32 h-4" />
							<div className="space-y-2">
								<Skeleton className="w-full h-4" />
								<Skeleton className="w-3/4 h-4" />
								<Skeleton className="w-1/2 h-4" />
							</div>
						</div>
					))}
				</div>
			</ScrollArea>
		);
	}

	if (!messages.length) {
		return (
			<ScrollArea className="h-[calc(70vh)]">
				<div className="space-y-4 pr-4">
					<div className="py-8 text-muted-foreground text-center">
						No messages found
					</div>
					<Alert>
						<AlertCircle className="w-4 h-4" />
						<AlertDescription>
							Messages are only retained for 30 days
						</AlertDescription>
					</Alert>
				</div>
			</ScrollArea>
		);
	}

	return (
		<ScrollArea className="h-[calc(70vh)]">
			<div className="space-y-4 pr-4">
				<MessageList messages={messages} />
				<Alert>
					<AlertCircle className="w-4 h-4" />
					<AlertDescription>
						Messages are only retained for 30 days
					</AlertDescription>
				</Alert>
			</div>
		</ScrollArea>
	);
}
